var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    staticClass: "addBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("添加版本")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "拼命加载中",
      "stripe": "",
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "版本号",
      "prop": "code",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上传时间",
      "prop": "createdAt",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "指定设备",
      "prop": "device",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "platform",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "remark",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.updateVersion(scope.row)
            }
          }
        }, [_vm._v("更新版本")])]
      }
    }])
  })], 1), _vm._v(" "), _c('Page', {
    attrs: {
      "way": _vm.ways
    },
    on: {
      "pageNum": _vm.pageNum,
      "pageOne": _vm.pageOne
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "版本操作",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "label-width": _vm.formLabelWidth,
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.form.code = $$v
      },
      expression: "form.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件地址",
      "label-width": _vm.formLabelWidth,
      "prop": "fileUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.fileUrl),
      callback: function($$v) {
        _vm.form.fileUrl = $$v
      },
      expression: "form.fileUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指定设备",
      "label-width": _vm.formLabelWidth,
      "prop": "device"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.hid),
      callback: function($$v) {
        _vm.hid = $$v
      },
      expression: "hid"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.hid,
        "value": item.hid
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本",
      "label-width": _vm.formLabelWidth,
      "prop": "platform"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.platform),
      callback: function($$v) {
        _vm.form.platform = $$v
      },
      expression: "form.platform"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "xtg_v01",
      "value": "xtg_v01"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "xtg_v02",
      "value": "xtg_v02"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "lua_v01",
      "value": "lua_v01"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.form.remark = $$v
      },
      expression: "form.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.editLoad) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editOpt('form')
      }
    }
  }, [_vm._v("编 辑")]) : _vm._e(), _vm._v(" "), (_vm.addLoad) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addOpt('form')
      }
    }
  }, [_vm._v("添 加")]) : _vm._e()], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6005c307","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/version/Version.vue
// module id = Qbf+
// module chunks = 1